<template>
    <HeroSection :featureName="baseFeature.name" :icon="baseFeature.icon">
        <template #title>{{ baseFeature.description }}</template>
        <template #description>
            <p>Keep your attendees informed with targeted emails and communications. Easily filtered and queued for sending.</p>
            <p class="mt-4">Send invitation links to Contacts to drive registrations.</p>
            
        </template>
        <template #content>
            <div class="w-full relative h-[500px]">
                <div class="absolute top-0 left-0 w-1/2 h-full" >
                    <DeviceWrapper deviceType="phone" :width="80" :z="0" :x="0" :y="12" :rotateOnScroll="true" :imageSrc="appImage" />
                </div>

                <div class="absolute top-0 right-12 w-1/2 h-full" >
                    <DeviceWrapper deviceType="phone" :width="80" :z="0" :x="0" :y="-16" :rotateOnScroll="true" :imageSrc="appImage2" />
                </div>

                <div v-reveal class="absolute bottom-0 right-0 w-64 h-64 ">
                    <img src="/src/images/megaphone.svg" alt="Badge" class="w-full h-full object-contain" />
                </div>
            </div>
        </template>
    </HeroSection>

    <CmsLarge title="Emails Template Builder" copy="Create mobile and desktop friendly emails with our drag-and-drop builder. Add content blocks, buttons and speciality blocks like QR codes and App Download Links alongside merge tags." :imageSrc="emailImage" />

    <Tips :title="baseFeature.name" :tips="tips" />
    <WorksWith :title="baseFeature.name" :integrations="integrations" />
    <Cta />
</template>

<script setup>
import Cta from '../../components/Blocks/Cta.vue';
import HeroSection from '../../components/HeroSection.vue';
import CmsAndApp from '../../components/Layouts/CmsAndApp.vue';
import Tips from '../../components/Blocks/Tips.vue';
import WorksWith from '../../components/Blocks/WorksWith.vue';
import DeviceWrapper from '@/components/DeviceWrapper.vue';
import CmsLarge from '@/components/Layouts/CmsLarge.vue';
import { getFeaturesByIds } from '../../router/features';


import appImage from '@/images/screenshots/web/theme-1-email-phone.png';
import appImage2 from '@/images/screenshots/app/theme-1/notifications.png';

import emailImage from '@/images/screenshots/cms/email-template-builder.png';

const tips = [
    'Queue an email and notification the morning of the event to explain your check-in process.',
    'Notifications can be linked to pages within the App. A great opportunity to offer your Sponsors a chance to promote their products and services.',
    'Add your own sending domain and email address to ensure an end-to-end, fully branded solution for your event.',
    'Profile Filters will be applied to queued emails at time of sending. Stop the last minute import and export of Contacts to ensure your emails are sent to the right people.'
];

const baseFeature = getFeaturesByIds(['emailsandcommunications'])[0];
const integrations = getFeaturesByIds(['registrationandtickets', 'leadcapture', 'eventapp']);
</script>
